export default "__VITE_ASSET__CT02LrrF__"